// extracted by mini-css-extract-plugin
module.exports = {"cards":"step-5_cards__3FNhd","card":"step-5_card__1L-r7","selectedCard":"step-5_selectedCard__21XdI","subtitle":"step-5_subtitle__3vjS4"};